export { ReactComponent as Replace } from './svgs/replace.svg';
